var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobalProvide7 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 36,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#global-provide-7_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "global-provide-7_svg__b",
  width: 40,
  height: 36,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M40 .5H0v35h40z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#global-provide-7_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#408BFC",
  d: "m32.768 1.413-5.282 8.534c-.31.5.122 1.132.696 1.016l5.02-1.013a.7.7 0 0 1 .262 0l5.021 1.013c.574.116 1.006-.516.696-1.016L33.9 1.413a.663.663 0 0 0-1.13 0M7.232 34.587l5.283-8.534c.31-.5-.123-1.132-.696-1.016L6.797 26.05a.7.7 0 0 1-.261 0l-5.021-1.014c-.573-.116-1.006.516-.696 1.017L6.1 34.587a.663.663 0 0 0 1.131 0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6.667 20.692V9.25c0-2.23 1.79-4.038 4-4.038H20M33.333 15.308v12.115c0 2.23-1.79 4.039-4 4.039H20"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "global-provide-7_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h40v35H0z"
})))));
export default SvgGlobalProvide7;